import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { persistor, store } from '@store'
import { clearLogin } from '@views/loginView/state/loginSlice'
import { setUnauthorizedHandler } from '@http/client'

setUnauthorizedHandler(async () => {
  store.dispatch(clearLogin())
  await persistor.flush()
})

ReactDOM.render(<App />, document.getElementById('root'))

reportWebVitals()
